// REACT
import { createBrowserRouter } from "react-router-dom";

// COMPONENTS
import PrimaryLayout from "../components/layouts/PrimaryLayout.js";

// Pages
import Home from "../pages/Home.js";
import ProductManager from "../pages/ProductManager.js";
import UploadManager from "../pages/UploadManager.js";
import ExportManager from "../pages/ExportManager.js";
import ConflictResolver from "../pages/ConflictResolver.js";
import ErrorPage from "../pages/ErrorPage";
import NotFound from "../pages/NotFound.js";
import ShopManager from "../pages/ShopManager.js";

// Base path
export const basePath = "/";

// Admin Router
export const adminRouter = createBrowserRouter([
  {
    path: basePath,
    element: <PrimaryLayout />,
    errorElement: <ErrorPage />,
    children: [
      { path: basePath, element: <Home /> },
      { path: `${basePath}/upload`, element: <UploadManager /> },
      { path: `${basePath}/export`, element: <ExportManager /> },
      { path: `${basePath}/productmanager`, element: <ProductManager /> },
      { path: `${basePath}/conflictresolver`, element: <ConflictResolver /> },
      { path: `${basePath}/shopmanager`, element: <ShopManager /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);

// User Router
export const userRouter = createBrowserRouter([
  {
    path: basePath,
    element: <PrimaryLayout />,
    errorElement: <ErrorPage />, 
    children: [
      { path: `${basePath}`, element: <UploadManager /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
